import { styled } from 'libs/ui/styled';

export const HintContainer = styled('span')({
  display: 'inline-flex',
  transform: 'translateY(2px) translateX(4px)',
});
